import React from 'react';

function EPK() {
  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'flex-start', 
      alignItems: 'center',
      padding: '10px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        marginBottom: '30px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        textAlign: 'center'
      }}>
        <a 
          href="https://twangville.com/2025/12/10/mayers-playlist-for-fall-winter-2025-part-1/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#8fce00',
            textDecoration: 'none',
            fontSize: '1rem',
            fontFamily: 'Arial, sans-serif',
            transition: 'opacity 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.7'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          Mayer’s Playlist for Fall/Winter 2025, Part 1 (2025/12/10) — twangville.com
        </a>
        <a 
          href="https://uglyhug.com/2025/10/09/if-you-can-hear-her-you-should-fear-her-one-of-the-guys-by-zoe-pete-ford-album-review/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#8fce00',
            textDecoration: 'none',
            fontSize: '1rem',
            fontFamily: 'Arial, sans-serif',
            transition: 'opacity 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.7'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          If You Can Hear Her You Should Fear Her (2025/10/09) — uglyhug.com
        </a>
        <a 
          href="https://uglyhug.com/2025/12/10/zoe-pete-ford-x-ugly-hug-guest-list-vol-86/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#8fce00',
            textDecoration: 'none',
            fontSize: '1rem',
            fontFamily: 'Arial, sans-serif',
            transition: 'opacity 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.7'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          Zoë Pete Ford x ugly hug | Guest List vol. 86 (2025/12/10) — uglyhug.com
        </a>
      </div>
      <img 
        src="/images/presspage.png" 
        alt="Press Page" 
        style={{ 
          maxWidth: '100%', 
          maxHeight: 'calc(100vh - 200px)', 
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }} 
      />
    </div>
  );
}

export default EPK;
